import { render, staticRenderFns } from "./PurchaseSteps.vue?vue&type=template&id=9d455540&"
import script from "./PurchaseSteps.vue?vue&type=script&lang=js&"
export * from "./PurchaseSteps.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSteps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports